import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AttributeValue, EditedAttributeValues } from '../../../../../models/section-definition.model';
import { ContainerNames } from '../../../../../models/container-names.model';
import { BlobStorageService } from '../../../../../services/blob-storage.service';
import { AttributeValidationError } from '../attribute-number-edit-row/attribute-number-edit-row.component';

// An image can only be replaced by uploading a new one, so the only rule is that a required image is not empty.
export function getImageValidationError(
  attr: AttributeValue,
  url: string | null,
): AttributeValidationError | null {
  return !url && attr.isRequired ? { key: 'COMMON.ATTRIBUTE_VALIDATION.REQUIRED' } : null;
}

@Component({
  selector: 'lib-attribute-image-edit-row',
  standalone: false,
  templateUrl: './attribute-image-edit-row.component.html',
  styleUrls: ['./attribute-image-edit-row.component.scss'],
})
export class AttributeImageEditRowComponent implements OnInit {
  @Input() attributeValue!: AttributeValue;
  @Input() editedValues: EditedAttributeValues = {};
  value: string | null = null;
  uploading: boolean = false;
  error: AttributeValidationError | null = null;

  constructor(
    private blobStorageService: BlobStorageService,
    private toastr: ToastrService,
  ) {}

  ngOnInit(): void {
    const id = this.attributeValue.attributeDefinitionId;
    this.value = ((id in this.editedValues ? this.editedValues[id] : this.attributeValue.stringValue) as string | null) || null;
    this.error = getImageValidationError(this.attributeValue, this.value);
  }

  // The file is uploaded to blob storage right away; only its URL goes into the edited values.
  onFileChange({ file }: { file: File }) {
    if (!file.type.startsWith('image/')) {
      this.toastr.warning('Please select an image file.');
      return;
    }

    this.uploading = true;
    this.blobStorageService.setContainer(ContainerNames.Images);
    this.blobStorageService.uploadFile(
      file,
      file.name,
      (url) => {
        this.uploading = false;
        this.value = url;
        this.editedValues[this.attributeValue.attributeDefinitionId] = url;
        this.error = null;
      },
      () => {
        this.uploading = false;
        this.toastr.error('Error occurred while uploading image');
      },
    );
  }
}
